"use client";
import cn from "clsx";
import { Button, Flex, Tooltip } from "@radix-ui/themes";
import { fetchHost } from "@/util/fetchutil";
import { LayoutProps } from "@/components/layout/layoutType";
import { useTranslations } from "next-intl";
import { deleteCookie } from "@/util/cookies";
import { Debug } from "@/util/debug";
import { AlertContext } from "@/components/context/alertContext";
import { useContext } from "react";
// import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";

import Icon from "@/components/common/icon/icon";
import Link from "next/link";
import { alertLoading } from "../list/defaultType";
export default function ReloadButton({ className, offline }: { className?: string; offline: boolean }) {
  const ta = useTranslations("alert");
  const alertContext = useContext(AlertContext);

  const ReloadButtonClick = () => {
    const alert_p = alertContext.setProp; //params?.alertFunction;
    if (alert_p) {
      const online = navigator.onLine ?? true;
      alert_p({
        open: true,
        title: ta("reload"),
        description: online ? ta("reload_detail") : ta("offline_text"),
        useCancel: online,
        useOk: true,
        okFunction: () => {
          if (online) {
            setTimeout(() => {
              alert_p(alertLoading);
              location.reload();
            }, 50);
          }
        },
      });
    }
  };
  const iconName = offline ? "WifiSlash" : "ArrowClockwise";
  const title = offline ? ta("offline_text") : ta("reload");

  return (
    <Flex direction="column" className={cn(className, "overflow-hidden")}>
      <Button
        color="gray"
        variant="ghost"
        className="outline-0 cursor-pointer group hover:bg-transparent"
        id="tool_sign_button"
        aria-label="Tool Sign Button"
        onClick={ReloadButtonClick}
      >
        <Tooltip content={title}>
          <Flex align="center" gap="2" className="p-1 ">
            <Icon
              iconType="phosphor"
              iconName={iconName}
              className={cn(
                "w-5 h-5",
                offline
                  ? "animate-infinite animate-pulse animate-duration-[1500ms] animate-delay-500 animate-fill-backwards"
                  : "group-hover:animate-spin group-hover:animate-infinite",
              )}
            />
          </Flex>
        </Tooltip>
      </Button>
    </Flex>
  );
}
